import { render, staticRenderFns } from "./SupplierList.vue?vue&type=template&id=21a16178&"
import script from "./SupplierList.vue?vue&type=script&lang=js&"
export * from "./SupplierList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21a16178')) {
      api.createRecord('21a16178', component.options)
    } else {
      api.reload('21a16178', component.options)
    }
    module.hot.accept("./SupplierList.vue?vue&type=template&id=21a16178&", function () {
      api.rerender('21a16178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/purchase/supplier/SupplierList.vue"
export default component.exports